import { observer } from 'mobx-react-lite';
import { Sparkles, Sun, Moon } from 'lucide-react';
import { useAuthController } from '@/controllers/auth/useAuthController';
import { themeStore } from '@/stores/theme.store';
import { runInAction } from 'mobx';
import { Button } from '@/components/ui/button';
import { Characters } from './Characters';
import { LoginForm } from './LoginForm';
import { palette } from '@/design/tokens';

export const LoginPage = observer(function LoginPage() {
  const isDark = themeStore.theme === 'dark';
  const { store, setField, handleSubmit } = useAuthController();

  return (
    <div className='min-h-screen grid lg:grid-cols-2'>
      <div
        className='relative hidden lg:flex flex-col justify-between p-12 text-[#FAFFFD] overflow-visible'
        style={{ backgroundColor: isDark ? palette.dark : palette.blue }}
      >
        <div className='relative z-20'>
          <div className='flex items-center gap-2 text-lg font-semibold'>
            <div className='size-8 rounded-lg bg-[#FAFFFD]/10 backdrop-blur-sm flex items-center justify-center'>
              <Sparkles className='size-4' />
            </div>
            <span>Биллинг LinkVideo</span>
          </div>
        </div>

        <div className='relative z-20 flex items-end justify-center h-125'>
          <Characters
            isTyping={store.isTyping}
            password={store.password}
            showPassword={store.showPassword}
            isDark={isDark}
          />
        </div>

        <div className='relative z-20 flex items-center justify-between text-sm text-[#FAFFFD]/80'>
          <Button
            type='button'
            variant='ghost'
            onClick={() => themeStore.toggle()}
            className='gap-2 hover:text-[#FAFFFD]'
          >
            {isDark ? <Sun className='size-4' /> : <Moon className='size-4' />}
            {isDark ? 'Светлая тема' : 'Тёмная тема'}
          </Button>
        </div>

        <svg
          className='absolute top-0 h-full z-10 pointer-events-none'
          style={{ left: '100%', width: '64px' }}
          viewBox='0 0 64 1000'
          preserveAspectRatio='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0,0 L36,0 C54,60 14,140 44,220 C64,300 18,390 46,480 C66,560 16,650 42,740 C58,810 22,880 32,940 C38,970 20,990 24,1000 L0,1000 Z'
            fill={isDark ? palette.dark : palette.blue}
          />
        </svg>

        <div className='absolute top-1/4 right-1/4 size-64 bg-[#FAFFFD]/5 rounded-full blur-3xl' />
        <div className='absolute bottom-1/4 left-1/4 size-96 bg-[#FAFFFD]/3 rounded-full blur-3xl' />
      </div>

      <div className='relative flex items-center justify-center p-8 bg-background'>
        <div className='w-full max-w-100'>
          <div className='lg:hidden flex items-center justify-center gap-2 text-lg font-semibold mb-10'>
            <div className='size-8 rounded-lg bg-primary/10 flex items-center justify-center'>
              <Sparkles className='size-4 text-primary' />
            </div>
            <span>Биллинг LinkVideo</span>
          </div>

          <div className='mb-8 text-center'>
            <h1 className='text-2xl font-medium tracking-wider mb-1'>Добро пожаловать</h1>
            <p className='text-muted-foreground text-sm'>Корпоративная авторизация</p>
          </div>

          <LoginForm
            credentials={{
              login: store.login,
              password: store.password,
              rememberMe: store.rememberMe,
            }}
            showPassword={store.showPassword}
            state={{
              isLoading: store.isLoading,
              error: store.error,
              isAuthenticated: store.isAuthenticated,
            }}
            onFieldChange={setField}
            onShowPasswordToggle={() =>
              runInAction(() => {
                store.showPassword = !store.showPassword;
              })
            }
            onSubmit={handleSubmit}
            onLoginFocus={() =>
              runInAction(() => {
                store.isTyping = true;
              })
            }
            onLoginBlur={() =>
              runInAction(() => {
                store.isTyping = false;
              })
            }
          />

          <p className='text-center text-xs text-muted-foreground/60 mt-6'>
            Биллинг LinkVideo · Корпоративная система
          </p>
        </div>
      </div>
    </div>
  );
});
